"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ampersandCollection = _interopRequireDefault(require("ampersand-collection"));
var _token = _interopRequireDefault(require("./token"));
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

var TokenCollection = _ampersandCollection.default.extend({
  mainIndex: 'scope',
  model: _token.default,
  namespace: 'Credentials'
});
var _default = TokenCollection;
exports.default = _default;
//# sourceMappingURL=token-collection.js.map
